// Custom stroke nav icons (Tabler-style) used in the sidebar. Inline SVG React
// components — no asset files needed. They inherit colour from the parent via
// currentColor, so the active/hover states in nav-item.js apply automatically.

const Svg = ({ children, size = 20, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    {children}
  </svg>
)

export const IconHome = props => (
  <Svg {...props}>
    <path d="M4 12l8-7 8 7" />
    <path d="M6 10v9h12v-9" />
  </Svg>
)

export const IconSales = props => (
  <Svg {...props}>
    <path d="M4 5h2l1.6 10h9.2L20 8H7" />
    <circle cx="9" cy="19" r="1.4" />
    <circle cx="17" cy="19" r="1.4" />
  </Svg>
)

export const IconInventory = props => (
  <Svg {...props}>
    <path d="M12 3l8 4v10l-8 4-8-4V7z" />
    <path d="M4 7l8 4 8-4" />
    <path d="M12 11v10" />
  </Svg>
)

export const IconInbound = props => (
  <Svg {...props}>
    <path d="M3 6h11v9H3z" />
    <path d="M14 9h4l3 3v3h-7z" />
    <circle cx="7.5" cy="17" r="1.5" />
    <circle cx="17.5" cy="17" r="1.5" />
  </Svg>
)

export const IconReturns = props => (
  <Svg {...props}>
    <path d="M9 7l-5 5 5 5" />
    <path d="M4 12h11a4 4 0 0 1 0 8h-1" />
  </Svg>
)

export const IconAnalytics = props => (
  <Svg {...props}>
    <path d="M4 20V4M4 20h16" />
    <path d="M8 17v-4M13 17v-7M18 17v-10" />
  </Svg>
)

// Volume = stacked layers (implies stacked order/shipment volume; distinct from
// the Analytics bar-chart icon). Retired with the Volume page split; kept for reuse.
export const IconVolume = props => (
  <Svg {...props}>
    <path d="M12 3l8 4.5-8 4.5-8-4.5z" />
    <path d="M4 12l8 4.5 8-4.5" />
    <path d="M4 16.5l8 4.5 8-4.5" />
  </Svg>
)

// Outbound analytics — arrow up out of a tray (goods leaving).
export const IconOutbound = props => (
  <Svg {...props}>
    <path d="M4 17v2a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-2" />
    <path d="M12 15V4" />
    <path d="M8 8l4-4 4 4" />
  </Svg>
)

// Inbound analytics — arrow down into a tray (goods arriving).
export const IconInboundArrow = props => (
  <Svg {...props}>
    <path d="M4 17v2a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-2" />
    <path d="M12 4v11" />
    <path d="M8 11l4 4 4-4" />
  </Svg>
)

export const IconFreight = props => (
  <Svg {...props}>
    <path d="M3 7h10v8H3z" />
    <path d="M13 10h4l3 3v2h-7z" />
    <circle cx="7" cy="17" r="1.4" />
    <circle cx="17" cy="17" r="1.4" />
  </Svg>
)

export const IconHelp = props => (
  <Svg {...props}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M9.5 9.5a2.5 2.5 0 0 1 4.5 1.5c0 1.6-2 2-2 3" />
    <path d="M12 17h.01" />
  </Svg>
)

// Logout — arrow pointing OUT to the left, door on the right.
export const IconLogout = props => (
  <Svg {...props}>
    <path d="M14 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-4" />
    <path d="M9 8l-4 4 4 4" />
    <path d="M5 12h10" />
  </Svg>
)

// Version — a release tag.
export const IconVersion = props => (
  <Svg {...props}>
    <path d="M9.6 4H5a1 1 0 0 0-1 1v4.6a1 1 0 0 0 .3.7l8.4 8.4a1 1 0 0 0 1.4 0l4.6-4.6a1 1 0 0 0 0-1.4L10.3 4.3A1 1 0 0 0 9.6 4z" />
    <circle cx="8" cy="8" r="1.2" />
  </Svg>
)
